export default {
  "header": {
    "search": "Buscar"
  },
  "help": {
    "code": "Corresponde al identificador único del conductor, el cual puede ser su rut u otro código definido por la empresa.",
    "codeVehicle": "Corresponde al identificador único del equipo, el cual puede ser su placa de registro vehícular u otro código definido por la empresa.",
    "codeSemiTrailer": "Corresponde al identificador único de la rampla, el cual puede ser su placa de registro vehícular u otro código definido por la empresa.",
    "codeGeo": "Corresponde al código identificador de la geozona.",
    "dataSource": "Corresponde a los códigos del conductor provenientes de fuentes de información externas: SAP, ERP’s, otros.",
    "dataSourceVehicle": "Corresponde a los códigos del equipo provenientes de fuentes de información externas: SAP, ERP’s, otros.",
    "dataSourceSemiTrailer": "Corresponde a los códigos de la rampla provenientes de fuentes de información externas: SAP, ERP’s, otros.",
    "workingShiftGroupHelp": "Corresponde al grupo de rotación de turno al que está asignada la persona en la fecha de consulta.",
    "state": {
      "title": "Representa el estado de asociación a fuentes de información.",
      "listDatasource": {
        "name": "-Asociado a fuente de información",
        "text": ": conductor con al menos una fuente de información configuradas en la plataforma.",
        "textVehicle": ": equipo con al menos una fuente de información configuradas en la plataforma.",
        "textSemiTrailer": ": rampla con al menos una fuente de información configuradas en la plataforma."
      },
      "noListDatasource": {
        "name": "-Sin asociaciones a fuentes de información",
        "text": ": conductor sin ninguna fuente de información asociada.",
        "textVehicle": ": equipo sin ninguna fuente de información asociada.",
        "textSemiTrailer": ": rampla sin ninguna fuente de información asociada."
      }
    }
  },
  "expire": {
    "vehicules": {
      "title": "Asociación equipo"
    },
    "semiTrailers": {
      "title": "Asociación rampla"
    },
    "text": "la conexión ha caducado"
  },
  "title": {
    "driver": "Nómina de conductores",
    "vehicules": "Nómina de equipos",
    "semiTrailers": "Nómina de ramplas",
    "homologation": "Conductores desconocidos",
    "homologationVehicle": "Equipos desconocidos",
    "homologationSemiTrailer": "Ramplas desconocidas",
    "workingShiftGroup": "Grupos de turno"
  },
  "table": {
    "code": "Código",
    "name": "Nombre",
    "dataSource": "Códigos en fuentes de información",
    "state": "Estado",
    "setting": "Acciones",
    "endTime": "No hay más datos",
    "row": "Fila",
    "workingShiftGroup": "Grupo de turno"
  },
  "homologationDriver": {
    "AssociateTeam": "Asociar equipo",
    "createTeam": "Crear equipo",
    "AssociateSemiTrailer": "Asociar rampla",
    "createSemiTrailer": "Crear rampla",
    "downloadExcel": "Descargar Plantilla Excel",
    "importExcelFile": "Importar Plantilla Excel",
    "downloadFileName": "homologacionConductor",
    "table": {
      "source": "Fuente de información",
      "dataSource": "Nombre de la fuente de información externa: SAP, ERP’s, otros.",
      "codeExterno": "Código del conductor proveniente de la fuente de información externa: SAP, ERP’s, otros.",
      "codeExternoVehicle": "Código del equipo proveniente de la fuente de información externa: SAP, ERP’s, otros.",
      "codeExternoSemiTrailer": "Código de la rampla proveniente de la fuente de información externa: SAP, ERP’s, otros.",
      "dataSourceAlias": "Información del conductor obtenida desde la fuente de información externa.",
      "dataSourceVehicle": "Información del equipo obtenida desde la fuente de información externa.",
      "dataSourceSemiTrailer": "Información de la rampla obtenida desde la fuente de información externa.",
      "code": "Código externo",
      "alias": "Información del conductor",
      "aliasVehicle": "Información del equipo",
      "aliasSemiTrailer": "Información de la rampla",
      "codeAndName": "Conductor existente que se asignará",
      "codeAndNameVehicle": "Equipo existente que se asignará",
      "codeAndNameSemiTrailer": "Rampla existente que se asignará",
      "selectDriver": "Por favor seleccione un conductor",
      "selectVehicle": "Por favor seleccione un equipo",
      "selectSemiTrailer": "Por favor seleccione una rampla"
    },
    "vehicules": "Equipos",
    "semiTrailers": "Ramplas",
    "detail": "Detalle",
    "code": "Código",
    "name": "Nombre",
    "text": "Corresponde al identificador único del conductor, el cual puede ser su rut u otro código definido por la empresa.",
    "textVehicle": "Corresponde al número de identificación del equipo, el cual puede ser su rut u otro número definido por la empresa.",
    "textSemiTrailer": "Corresponde al número de identificación de la rampla, el cual puede ser su rut u otro número definido por la empresa.",
    "filterText": "Seleccione el/los ítems al que pertenece el conductor",
    "filterTextUser": "Seleccione el/los ítems al que pertenece el usuario",
    "source": "Fuente",
    "dataSourceDescent": "Complete los códigos del equipo provenientes de fuentes de información externas: SAP, ERP`s, otros.",
    "dataSourceSemiTrailerDescent": "Complete los códigos de la rampla provenientes de fuentes de información externas: SAP, ERP`s, otros.",
    "type": "Tipo",
    "feedBackDriverOk": "Vehículo creado y asociado a la fuente de información.",
    "feedBackDriverWarning": "Vehículo creado pero sin asociar a fuentes de información.",
    "feedBackSemiTrailerOk": "Rampla creada y asociada a la fuente de información.",
    "feedBackSemiTrailerWarning": "Rampla creada pero sin asociar a fuentes de información.",
    "teamCreateSuccess": "Asociación realizada con éxito.",
    "howCreatedExcel": "¿Descargar plantilla excel?",
    "browserIssue": "Your browser does not support the video tag.",
    "buttonDownload": "Descargar plantilla de formato",
    "createVehicule": "Crear equipo",
    "dataSource": "Fuentes de información"
  },
  "modalDriver": {
    "buttonCreat": "Crear Conductor",
    "textLabel": "Por favor seleccione el archivo nómina de conductores que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo:",
    "buttonDelete": "Desactivar",
    "teamLabel": "Por favor seleccione el archivo nómina de equipos que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo",
    "buttonActive": "Activar",
    "buttonCancel": "Cancelar",
    "buttonEdit": "Actualizar Conductor",
    "buttonUpdate": "Actualizar",
    "buttonUpdateFile": "Enviar archivo",
    "buttonDownload": "Descargar plantilla de formato",
    "createDriverTitle": "Crear Conductor",
    "deleteDriverTitle": "Desactivar conductor",
    "activeDriverTitle": "Activar conductor",
    "editDriverTitle": "Editar conductor",
    "loading": "Cargando !!!",
    "feedBackDriverOk": "Conductor creado y asociado a la fuente de información.",
    "feedBackDriverWarning": "Conductor creado sin fuentes de información asociadas.",
    "feedBackDriverOkEdit": "Conductor actualizado y asociado a la fuente de información.",
    "feedBackDriverWarningEdit": "Conductor actualizado sin fuentes de información asociadas.",
    "feedBackDriverDeleteOne": "El conductor",
    "feedBackDriverDeleteTwo": "fue desactivado exitosamente.",
    "feedBackDriverActiveOne": "El conductor",
    "feedBackDriverActiveTwo": "fue activado exitosamente.",
    "feedBackDriverUpdateOne": "Datos fueron cargados con éxito",
    "feedBackDriverUpdateTwo": "Error: resuelva estos problemas y vuelva a cargar el archivo.",
    "feedBackDriverUpdateThree": "Advertencia: El sistema permite ingresar datos, pero podrían traer problemas si no se corrigen.",
    "code": "Código",
    "name": "Nombre",
    "examine": "Examinar",
    "row": "Fila",
    "type": "Tipo",
    "detail": "Detalle",
    "dataSource": "Códigos en fuentes de información",
    "downloadExcel": "Descargar Plantilla Excel",
    "dataSourceDescent": "Complete los códigos del conductor provenientes de fuentes de información externas: SAP, ERP`s, otros.",
    "selectTags": "Seleccione: Los ítems al que pertenece el conductor",
    "ErrorDelete": "Error al desactivar",
    "isSureToDeleteOne": "¿ Está seguro que desea desactivar el conductor",
    "isSureToDeleteTwo": "de la plataforma ?",
    "isSureToDeleteThree": "* Está acción hará que desde este momento no se visualicen los datos de este conductor.",
    "isSureToDeleteFour": "¿ Está seguro que desea activar al conductor",
    "isSureToDeleteFive": "de la plataforma ?",
    "isSureToDeleteSix": "* Está acción hará que desde este momento se visualicen los datos de este conductor.",
    "howCreatedExcel": "¿Descargar plantilla excel?",
    "browserIssue": "Your browser does not support the video tag.",
    "normalText": "Por favor seleccione el archivo nómina de conductores que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo:",
    "normalTextUser": "Por favor seleccione el archivo nómina de usuarios que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo:",
    "cognusMailConfig": {
      "title": "Destinatarios voucher digital",
      "placeholder": "Introduzca los correos",
      "description": "Corresponde al grupo de correos a los que se les enviará el voucher digital cada vez que este conductor finalice una prueba PVT",
      "helpText": "Puede ingresar más de un correo utilizando como separador una coma, la tecla ESPACIO o ENTER."
    },
    "howCreatedExcelAssociateUsers": "¿Descargar plantilla excel para asociar usuarios?",
    "normalTextUserAssociateUsers": "Por favor seleccione el archivo para asociar usuarios con conductores que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo:",
    "messageErrorResultAssociateUsers": "El resultado del proceso de asociación de usuarios presentó algunos errores que debes revisar en el archivo descargado<br />(<b>total de errores</b>: {totalErrors})",
    "downloadFileNameAssociateUsers": "asociar-usuarios",
    "downloadFileNameResultAssociateUsers": "resultado-asociacion-usuarios"
  },
  "filterDriver": {
    "show": "Mostrar",
    "allDriver": "Todos los conductores",
    "allVehicules": "Todos los equipos",
    "allSemiTrailers": "Todas las ramplas",
    "associatedDriver": "Conductores asociados a fuentes de información",
    "associatedVehicle": "Equipos asociados a fuentes de información",
    "associatedSemiTrailer": "Ramplas asociadas a fuentes de información",
    "associatedDriverOne": "Asociado a fuente de información",
    "pendingDriver": "Conductores sin fuentes de información",
    "desactiveUser": "Usuarios desactivados",
    "desactiveDriver": "Conductores dados de baja",
    "desactiveVehicles": "Equipos dados de baja",
    "desactiveSemiTrailers": "Ramplas dadas de baja",
    "activeDriver": "Conductores registrados",
    "activeVehicles": "Equipos registrados",
    "activeSemiTrailers": "Ramplas registrados",
    "PendingPartnership": "Sin asociaciones a fuente de información"
  },
  "createDriver": {
    "create": "Crear Conductor",
    "createOne": "Crear conductores",
    "import": "Importar Excel",
    "importOne": "Importar conductores",
    "download": "Descargar plantilla",
    "associateDrivers": "Asociar conductores",
    "drivers": "Conductores",
    "downloadFileName": "conductor",
    "importUsers": "Cargar usuarios",
    "associateUsers": "Asociar usuarios"
  },
  "createUser": {
    "importOne": "Importar usuario",
    "downloadFileName": "usuarios"
  },
  "createVehicules": {
    "creates": "Crear equipos",
    "create": "Crear equipo",
    "import": "Importar excel",
    "download": "Descargar plantilla",
    "name": "Nombre",
    "code": "Código",
    "text": "Corresponde al número de identificación del conductor, el cual puede ser su rut u otro número definido por la empresa.",
    "filterText": "Seleccione el/los ítems al que pertenece el equipo",
    "dataSource": "Códigos en fuentes de información",
    "dataSourceDescent": "Complete los códigos del equipo provenientes de fuentes de información externas: SAP, ERP`s, otros.",
    "editDriverTitle": "Editar equipo",
    "feedBackOkEdit": "Equipo creado y asociado a la fuente de información.",
    "feedBackWarningEdit": "Equipo creado sin fuentes de información asociadas.",
    "downloadFileName": "equipo",
    "downloadFileNameHomologation": "homologacionEquipo"
  },
  "editVehicule": {
    "editVehiculeTitle": "Editar equipo",
    "name": "Nombre",
    "code": "Código",
    "codeText": "Corresponde al número de identificación del conductor, el cual puede ser su rut u otro número definido por la empresa.",
    "filterText": "Seleccione el/los transportista al que pertenece el conductor",
    "dataSource": "Fuentes de información",
    "dataSourceDescent": "Puedes crear al conductor sin completar este campo, sin embargo deberás completarlo antes de comenzar a operar en Gauss control para poder visualizarlo en la plataforma.",
    "buttonEdit": "Actualizar equipo",
    "feedBackDriverOkEdit": "Equipo actualizado y asociado a la fuente de información.",
    "feedBackDriverWarningEdit": "Equipo actualizado sin fuentes de información asociadas."
  },
  "deleteVehicule": {
    "deleteVehiculeTitle": "Desactivar vehículo",
    "isSureToDeleteOne": "¿ Está seguro que desea desactivar el equipo",
    "from": "de la plataforma ?",
    "isSureToDeleteThree": "* Está acción hará que desde este momento no se visualicen los datos de este equipo.",
    "buttonDelete": "Desactivar",
    "buttonCancel": "Cancelar",
    "feedBackDriverDeleteOne": "El equipo",
    "feedBackDriverDeleteTwo": "fue desactivado exitosamente.",
    "feedBackDriverDeleteThree": "fue activado exitosamente."
  },
  "activateVehicule": {
    "activateVehiculeTitle": "Activar Equipo",
    "isSureToActivateOne": "¿ Está seguro que desea activar al vehículo",
    "from": "de la plataforma ?",
    "isSureToActivateThree": "* Está acción hará que desde este momento se visualicen los datos de este vehículo.",
    "buttonActivate": "Activar",
    "buttonCancel": "Cancelar",
    "feedBackVehiculeActivateOne": "El equipo",
    "feedBackVehiculeActivateTwo": "fue desactivado exitosamente.",
    "feedBackVehiculeActivateThree": "fue activado exitosamente."
  },
  "updateVehicule": {
    "import": "Importar equipos",
    "examine": "Examinar",
    "activateVehiculeTitle": "Activar vehículo",
    "buttonUpdateFile": "Enviar archivo",
    "row": "Fila",
    "type": "Tipo",
    "feedBackVehiculeUpdateTwo": "Error: resuelva estos problemas y vuelva a cargar el archivo.",
    "feedBackVehiculeUpdateThree": "Advertencia: El sistema permite ingresar datos, pero podrían traer problemas si no se corrigen.",
    "feedBackVehiculeUpdateOne": "Datos fueron cargados con éxito",
    "isSureToActivateOne": "¿ Está seguro que desea activar al vehículo",
    "detail": "Detalle",
    "from": "de la plataforma ?",
    "isSureToActivateThree": "* Está acción hará que desde este momento se visualicen los datos de este vehículo.",
    "buttonActivate": "Actualizar",
    "buttonCancel": "Cancelar",
    "feedBackDriverUpdateOne": "Datos fueron cargados con éxito.",
    "feedBackVehiculeActivateOne": "El equipo",
    "feedBackVehiculeActivateTwo": "fue desactivado exitosamente.",
    "normalText": "Por favor seleccione el archivo nómina de equipos que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo:"
  },
  "createSemiTrailers": {
    "creates": "Crear ramplas",
    "create": "Crear rampla",
    "import": "Importar excel",
    "download": "Descargar plantilla",
    "name": "Nombre",
    "code": "Código",
    "text": "Corresponde al número de identificación de la rampla, el cual puede ser su patente u otro número definido por la empresa.",
    "filterText": "Seleccione el/los ítems al que pertenece a la rampla",
    "dataSource": "Códigos en fuentes de información",
    "dataSourceDescent": "Complete los códigos de la rampla provenientes de fuentes de información externas: SAP, ERP`s, otros.",
    "editDriverTitle": "Editar rampla",
    "feedBackOkEdit": "Rampla creada y asociada a la fuente de información.",
    "feedBackWarningEdit": "Rampla creada sin fuentes de información asociadas."
  },
  "editSemiTrailer": {
    "editSemiTrailerTitle": "Editar rampla",
    "name": "Nombre",
    "code": "Código",
    "codeText": "Corresponde al número de identificación de la rampla, el cual puede ser su patente u otro número definido por la empresa.",
    "filterText": "Seleccione el/los transportista al que pertenece la rampla",
    "dataSource": "Fuentes de información",
    "dataSourceDescent": "Puedes crear al conductor sin completar este campo, sin embargo deberás completarlo antes de comenzar a operar en Gauss control para poder visualizarlo en la plataforma.",
    "buttonEdit": "Actualizar rampla",
    "feedBackDriverOkEdit": "Rampla actualizada y asociada a la fuente de información.",
    "feedBackDriverWarningEdit": "Rampla actualizada sin fuentes de información asociadas."
  },
  "deleteSemiTrailer": {
    "deleteSemiTrailerTitle": "Desactivar rampla",
    "isSureToDeleteOne": "¿ Está seguro que desea desactivar la rampla",
    "from": "de la plataforma ?",
    "isSureToDeleteThree": "* Está acción hará que desde este momento no se visualicen los datos de esta rampla.",
    "buttonDelete": "Desactivar",
    "buttonCancel": "Cancelar",
    "feedBackDriverDeleteOne": "La rampla",
    "feedBackDriverDeleteTwo": "fue desactivado exitosamente.",
    "feedBackDriverDeleteThree": "fue activado exitosamente."
  },
  "activateSemiTrailer": {
    "activateSemiTrailerTitle": "Activar Rampla",
    "isSureToActivateOne": "¿ Está seguro que desea activar la rampla",
    "from": "de la plataforma ?",
    "isSureToActivateThree": "* Está acción hará que desde este momento se visualicen los datos de esta rampla.",
    "buttonActivate": "Activar",
    "buttonCancel": "Cancelar",
    "feedBackSemiTrailerActivateOne": "La rampla",
    "feedBackSemiTrailerActivateTwo": "fue desactivado exitosamente.",
    "feedBackSemiTrailerActivateThree": "fue activado exitosamente."
  },
  "updateSemiTrailer": {
    "import": "Importar ramplas",
    "examine": "Examinar",
    "activateSemiTrailerTitle": "Activar rampla",
    "buttonUpdateFile": "Enviar archivo",
    "row": "Fila",
    "type": "Tipo",
    "feedBackSemiTrailerUpdateTwo": "Error: resuelva estos problemas y vuelva a cargar el archivo.",
    "feedBackSemiTrailerUpdateThree": "Advertencia: El sistema permite ingresar datos, pero podrían traer problemas si no se corrigen.",
    "feedBackSemiTrailerUpdateOne": "Datos fueron cargados con éxito",
    "isSureToActivateOne": "¿ Está seguro que desea activar la rampla",
    "detail": "Detalle",
    "from": "de la plataforma ?",
    "isSureToActivateThree": "* Está acción hará que desde este momento se visualicen los datos de esta rampla.",
    "buttonActivate": "Actualizar",
    "buttonCancel": "Cancelar",
    "feedBackDriverUpdateOne": "Datos fueron cargados con éxito.",
    "feedBackSemiTrailerActivateOne": "La rampla",
    "feedBackSemiTrailerActivateTwo": "fue desactivado exitosamente.",
    "normalText": "Por favor seleccione el archivo nómina de ramplas que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo:"
  },
  "roles": {
    "FatigueModuleFullAccess": "Permite visualizar reportabilidad de módulo biocompatibilidad completa (resumen, detalle y conductor).",
    "RoadWarningModuleFullAccess": "Permite visualizar reportabilidad de módulo eventos de somnolencia completa (resumen, detalle y conductor).",
    "AccountManagerReadOnly": "Permite visualizar listado de conductores, equipos y geozonas configurados en la plataforma.",
    "BehaviorModuleFullAccess": "Permite visualizar reportabilidad de módulo conductual completa (resumen, detalle y conductores).",
    "ManageFullAccess": "Permite visualizar y gestionar todas las desviaciones activadas en el gestionador.",
    "AccountManagerCrudAccess": "Permite visualizar y configurar la plataforma (crear, editar y desactivar) conductores, equipos, categorías y geozonas. Además permite asociar equipos y conductores desconocidos con sus respectivos códigos de fuentes de información.",
    "AccountManagerUserRoleAccess": "Permite visualizar la plataforma y configurar usuarios (crear, editar y desactivar).",
    "ManageReadAccess": "Permite visualizar todas las desviaciones activadas en el gestionador.",
    "CFLModuleFullAccess": "Permite visualizar reportabilidad de módulo nfa completa (resumen, detalle y conductor).",
    "AssignmentFullAccess": "Permite visualizar y asignar conductores a equipos.",
    "WaitingTimesFullAccess": "Permite visualizar reportabilidad de módulo tiempos de espera.",
    "UserProfileFullAccess": "Permite al usuario visualizar y modificar su información personal.",
    "ApiInjection": "Permite usar los servicios de integración de API. A través de estos servicios es posible inyectar eventos y datos de telemetría en la plataforma Gauss Control.",
    "FormFullAccess": "Permite acceder y gestionar formularios a través de aplicación móvil y visualizar reportabilidad de flota e inspecciones.",
    "FlowRequestsAdmin": "Permite gestionar flujos de vehículos para una ruta determinada u otros.",
    "FlowRequestsApplicant": "Permite solicitar flujos de vehículos para una ruta determinada u otros.",
    "AlertnessInTimelineAccess": "Habilita la curva de alerta en las vistas que muestran las jornadas de trabajo como línea de tiempo (timeline).",
    "FFDSleepModuleFullAccess": "Permite visualizar reportabilidad de módulo FFD pulseras de sueño.",
    "FFDPVTModuleFullAccess": "Permite visualizar reportabilidad de módulo Cognus prueba pvt.",
    "ReclassificationInTasksManagementAccess": "Permite re-clasificar desviaciones en el gestionador.",
    "DeanonymizationInTasksManagementAccess": "Permite desanonimizar desviaciones en el gestionador.",
    "ManageCancelAccess": "Permite anular desviaciones en el gestionador.",
    "AnonymousFormReadAccess": "Permite visualizar inspecciones que no tienen ninguna categoría asignada",
    "ReportBIFullAccess": "Permite visualizar reportabilidad según los permisos que tenga el usuario.",
    "MediaDmsAccess": "Permite ver material multimedia asociado a eventos DMS",
    "MediaDashcamAccess": "Permite ver material multimedia asociado a eventos DASHCAM",
    "MediaDownloadAccess": "Permite ver y descargar material multimedia asociado a eventos",
    "MediaListenAudioAccess": "Permite escuchar audio de material multimedia asociado a eventos",
    "AccountManagerCrudAccessTags": "Permite visualizar la plataforma y agregar categorías.",
    "AccountManagerCrudAccessGeozones": "Permite visualizar la plataforma y configurar geozonas (crear, editar y desactivar).",
    "AccountManagerCrudAccessVehicles": "Permite visualizar la plataforma y configurar equipos y ramplas (crear, editar y desactivar). Además permite asociar equipos y ramplas con sus respectivas fuentes de información.",
    "AccountManagerCrudAccessDrivers": "Permite visualizar la plataforma y configurar conductores (crear, editar y desactivar). Además permite asociar conductores con sus respectivas fuentes de información.",
    "FormFullDynamicListAccess": "Permite crear y editar diversos listados de datos utilizados en el módulo de Formularios en la aplicación móvil",
    "MediaCognusFaceVerificationAccess": "Permite ver material multimedia asociado a eventos Cognus",
    "MediaUnidentifiedDriverAccess": "Permite ver material multimedia asociado a eventos de conductor no reconocido",
    "SaasApiConsumer": "Permite usar los servicios de integración de API. A través de estos servicios es posible inyectar eventos y datos de telemetría en la plataforma Gauss Control."
  },
  "geozone": {
    "base": "Base",
    "principal": "Mandante",
    "client": "Cliente",
    "onDuty": "Conducción",
    "productive": "Productiva",
    "stopped": "Detención",
    "withoutRest": "Tiempo de espera",
    "waitingtime": "Tiempo de espera",
    "workingplace": "Productiva",
    "activate": "Activar geozona",
    "activateText": "¿ Está seguro que desea activar la geozona",
    "howCreatedExcel": "¿Descargar plantilla excel?",
    "isSureActivateText": "* Está acción hará que desde este momento se visualicen los datos de esta geozona.",
    "trip": "Viaje",
    "row": "Fila",
    "type": "Tipo",
    "import": "Importar geozona(s)",
    "importExcel": "Importar Excel",
    "deactivate": "Desactivar Geozona",
    "code": "Código",
    "detail": "Detalle",
    "show": "Mostrar",
    "featureTextOne": "Característica",
    "allGeozone": "Todas las geozonas",
    "geozoneList": "Listado de geozonas",
    "geozoneDeactivated": "Geozonas dadas de baja",
    "geozoneActive": "Geozonas registradas",
    "downloadExcel": "Descargar Plantilla",
    "downloadFileName": "geozona",
    "geozoneName": "Nombre geozona",
    "examine": "Examinar",
    "isSureToDeleteOne": "¿ Está seguro que desea desactivar la geozona",
    "isSureToDeleteTwo": "de la plataforma ?",
    "browserIssue": "Your browser does not support the video tag.",
    "isSureToDeleteThree": "* Está acción hará que desde este momento no se visualicen los datos de está geozona.",
    "feedBackGeozoneUpdateThree": "Advertencia: El sistema permite ingresar datos, pero podrían traer problemas si no se corrigen.",
    "cancel": "Cancelar",
    "mapMessageOne": "Oh snap!",
    "mapMessageTwo": "you can't draw that!",
    "feedBackGeozoneEditOne": "La geozona",
    "feedBackGeozoneEditTwo": "fue desactivada exitosamente.",
    "feedBackGeozoneUpdateTwo": "Error: resuelva estos problemas y vuelva a cargar el archivo.",
    "buttonDelete": "Desactivar",
    "feedBackGeozoneUpdateOne": "Datos fueron cargados con éxito",
    "updatText": "Por favor seleccione el archivo nómina de geozona que desea cargar a la plataforma, el archivo debe poseer el formato definido en el siguiente archivo:",
    "modalCreate": {
      "create": "Crear Geozona",
      "import": "Importar geozona(s)",
      "name": "Nombre",
      "features": "Características geozona",
      "featureText": "Seleccione la/s características de esta geozona",
      "baseText": {
        "base": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "principal": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "client": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "onDuty": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "stopped": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "withoutRest": "Esta característica determina si la detención del conductor en esta zona se considera como trabajo (en vez de descanso). Esto afecta los indicadores de fatiga",
        "productive": "Esta característica determina si el tiempo de estadía de los vehículos se muestra en el módulo de tiempos de espera.",
        "trip": "Esta característica determina si la geozona será considerada para la creación y finalización de viajes en el módulo Conductual. Si no tiene esta característica, no se generarán viajes desde/hacia esta geozona.",
        "workingplace": "Esta característica determina si la detención del conductor en esta zona se considera como trabajo (en vez de descanso). Esto afecta los indicadores de fatiga.",
        "waitingtime": "Esta característica determina si el tiempo de estadía de los vehículos se muestra en el módulo de tiempos de espera."
      },
      "code": "Código",
      "codeText": "Corresponde al código identificador de la geozona.",
      "createSucces": "Geozona creada exitosamente.",
      "_codeText": "Corresponde al código identificador de la geozona."
    },
    "modalEdit": {
      "edit": "Editar Geozona",
      "editText": "Editar",
      "deactivateText": "Desactivar",
      "activateText": "Activar",
      "features": "Características geozona",
      "featureText": "Seleccione la/s características de esta geozona",
      "featureTextOne": "Característica",
      "name": "Nombre",
      "baseText": {
        "base": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "principal": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "client": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "onDuty": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "stopped": "Esta características determina el color con el que se muestra la esta día en geozona en la visualización de jornadas.",
        "withoutRest": "Esta característica determina si la detención del conductor en esta zona se considera como trabajo (en vez de descanso). Esto afecta los indicadores de fatiga",
        "productive": "Esta característica determina si el tiempo de estadía de los vehículos se muestra en el módulo de tiempos de espera.",
        "trip": "Esta característica determina si la geozona será considerada para la creación y finalización de viajes en el módulo Conductual. Si no tiene esta característica, no se generarán viajes desde/hacia esta geozona.",
        "workingplace": "Esta característica determina si la detención del conductor en esta zona se considera como trabajo (en vez de descanso). Esto afecta los indicadores de fatiga.",
        "waitingtime": "Esta característica determina si el tiempo de estadía de los vehículos se muestra en el módulo de tiempos de espera."
      },
      "code": "Código",
      "codeText": "Corresponde al código identificador de la geozona.",
      "buttonEdit": "Actualizar Geozona",
      "editSucces": "Geozona actualizada exitosamente.",
      "modelActivate": {
        "isSureToActivateOne": "* Está acción hará que desde este momento se visualicen los datos de esta geozona.",
        "isSureToActivateTwo": "de la plataforma ?",
        "buttonActivate": "Activar",
        "feedBackGeozoneActivateTwo": "fue activada exitosamente."
      }
    }
  },
  "accountUser": {
    "alertnessintimelineaccess": "Habilitar curva de alerta en líneas de tiempo de jornadas",
    "cflmodulefullaccess": "Ver Módulo NFA",
    "ffdsleepmodulefullaccess": "Ver Módulo Fitness for duty pulseras de sueño",
    "ffdpvtmodulefullaccess": "Ver Módulo Cognus prueba pvt",
    "accountmanagercrudaccess": "Configurar entidades",
    "accountmanagerreadonly": "Visualizar configuración de plataforma",
    "accountmanageruserroleaccess": "Configurar cuentas de usuarios",
    "apiinjection": "Proveedor de datos",
    "assignmentfullaccess": "Asignar conductores a equipos",
    "behaviormodulefullaccess": "Ver Módulo Conductual",
    "fatiguemodulefullaccess": "Ver Módulo Biocompatibilidad",
    "anonymousformreadaccess": "Ver inspecciones anónimas",
    "formfullaccess": "Gestionar Formularios",
    "managefullaccess": "Gestionar desviaciones",
    "managereadaccess": "Ver desviaciones",
    "reclassificationintasksmanagementaccess": "Re-clasificar desviaciones",
    "deanonymizationintasksmanagementaccess": "Desanonimizar desviaciones",
    "managecancelaccess": "Anular desviaciones",
    "roadwarningmodulefullaccess": "Ver Módulo Eventos de somnolencia",
    "waitingtimesfullaccess": "Ver Módulo Tiempos de espera",
    "userprofilefullaccess": "Ver perfil de usuario",
    "userAccount": "Listado de usuarios",
    "showUsers": "Mostrar: Todos los usuarios",
    "allUsers": "Todos los usuarios",
    "deactivateUsers": "Usuarios dados de baja",
    "activateUsers": "Usuarios registrados",
    "userRole": "Permisos: Todos",
    "userRoleTitle": "Permisos",
    "createUser": "Crear usuario",
    "userSuccess": "Usuario creado exitosamente.",
    "name": "Nombre",
    "email": "Mail (username)",
    "password": "Contraseña",
    "passwordError": "Las contraseñas no son iguales",
    "repeatPassword": "Repetir Contraseña",
    "currentPassword": "Contraseña actual",
    "newPassword": "Nueva contraseña",
    "isAdmin": "Es administrador",
    "rol": "Permisos",
    "labelSelection": "Seleccione uno o más permisos para este usuario",
    "rolLabel": "Corresponde al conjunto de permisos y funciones de la plataforma que están asignados al usuario.",
    "actions": "Acciones",
    "endOfTime": "No hay más datos",
    "editUser": "Editar usuario",
    "ActualizarUser": "Actualizar usuario",
    "updatePassword": "Actualizar Contraseña",
    "isUpdatePassword": "Contraseña actualizado",
    "userActivated": "Usuario actualizado",
    "deactivateUser": "Desactivar usuario",
    "activateUser": "Activar usuario",
    "activateUserOne": "Activar",
    "deactivateUserLabel": "¿ Está seguro que desea desactivar al usuario",
    "deactivateUserLabelOne": "de la plataforma ?",
    "deactivateUserLabelTwo": "* Está acción hará que desde este momento no se visualicen los datos de este usuario",
    "cancel": "Cancelar",
    "userTextOne": "El usuario",
    "userTextTwo": "ha sido desactivado, desde este momento no podrá acceder a la plataforma.",
    "userTextThree": "ha sido activado, desde este momento  podrá acceder a la plataforma.",
    "isSureToActivateOne": "¿ Está seguro que desea activar al usuario",
    "isSureToActivateTwo": "de la plataforma ?",
    "isSureToActivateThree": "* Está acción hará que desde este momento se visualicen los datos de este usuario.",
    "editPassWord": "Restablecer contraseña",
    "accountSettings": {
      "title": "Configuración del cliente",
      "save": "Guardar"
    },
    "flowrequestsadmin": "Ver Módulo Flujos - Administrador",
    "flowrequestsapplicant": "Ver Módulo Flujos - Aplicante",
    "reportbifullaccess": "Ver reportes",
    "mediadmsaccess": "Ver material multimedia DMS en cabina",
    "mediadashcamaccess": "Ver material multimedia DASHCAM",
    "mediadownloadaccess": "Descargar material multimedia",
    "medialistenaudioaccess": "Escuchar audio de material multimedia",
    "accountmanagercrudaccesstags": "Configuración categorías",
    "accountmanagercrudaccessgeozones": "Configuración geozonas",
    "accountmanagercrudaccessvehicles": "Configuración equipos y ramplas",
    "accountmanagercrudaccessdrivers": "Configuración conductores",
    "formfulldynamiclistaccess": "Configuración listas dinámicas en formulario",
    "mediacognusfaceverificationaccess": "Ver material enrolamiento Cognus",
    "mediaunidentifieddriveraccess": "Ver material multimedia - Conductor no identificado",
    "passwordChecklist": {
      "minLength": "La contraseña tiene más de 8 caracteres.",
      "specialChar": "La contraseña tiene caracteres especiales (!@#$%^&*).",
      "number": "La contraseña tiene un número (0-9).",
      "capital": "La contraseña tiene una letra mayúscula (A-Z).",
      "lowercase": "La contraseña tiene una letra minúscula (a-z).",
      "match": "Las contraseñas coinciden."
    },
    "massiveActions": "Acciones masivas",
    "saasapiconsumer": "Consumidor de API SaaS"
  },
  "accountAssigment": {
    "withoutConnection": "Vehículos sin conexión",
    "anonymousDriver": "(conductor anónimo)",
    "team": "Equipo",
    "hour": "Hora",
    "driver": "Conductor",
    "vehicleCode": "Codigo vehículo",
    "categorie": "Categorías",
    "assignDate": "Fecha asignación",
    "assignTime": "Tiempo asginado",
    "detail": "detalles",
    "headTitle": "Listado de asignación",
    "paragraphTitle": "En esta vista podrás revisar los conductores asignado a un vehículo este momento. Si un conductor no aparece es porque no está asignado a ningún equipo"
  },
  "workingShiftGroup": {
    "name": "Nombre",
    "workingShiftGroupType": "Tipo de turno",
    "workingShiftStructureDays": "Días de la estructura de turno",
    "workingShiftStartDate": "Fecha inicio régimen",
    "workingShiftGroupTypeHelp": "Corresponde al tipo de estructura del turno, siendo dinámico cuando no sigue un patrón fijo o con estructura fija cuando el patrón se repite en el tiempo, ejemplo: 5x2, 10x10, etc.",
    "workingShiftStructureDaysHelp": "Corresponde a la cantidad total de días que componen la estructura de turnos (días de trabajo y días de descanso).",
    "workingShiftStartDateHelp": "Corresponde a la fecha en la que comenzará a trabajar el grupo de trabajo.",
    "dynamicWorkingShift": "Turno dinámico",
    "fixedStructureWorkingShift": "Turno con estructura fija",
    "doesNotApply": "No aplica",
    "deactivateWorkingShiftGroup": "Eliminar grupo de turno",
    "deactivateWorkingShiftGroupLabel": "¿Estás seguro que quieres eliminar el grupo de turno",
    "deactivateWorkingShiftGroupLabelOne": "?",
    "deactivateWorkingShiftGroupLabelTwo": "* Si este grupo tuvo alguna vez personas asociadas, toda la información histórica se perderá.",
    "cancel": "Cancelar",
    "workingShiftGroupTextOne": "El grupo de turno",
    "workingShiftGroupTextTwo": "ha sido eliminado.",
    "deleteText": "Eliminar",
    "editText": "Editar",
    "cantDeleteHelp1": "No puedes eliminar este grupo de turno.",
    "cantDeleteHelp2": "Hay usuarios asignados a este grupo de trabajo.",
    "editModalTitle": "Editar grupo de turno",
    "buttonEdit": "Actualizar grupo de turno",
    "feedBackOkEdit": "Grupo de turno actualizado.",
    "createModalTitle": "Crear grupo de turno",
    "buttonCreate": "Crear grupo de turno",
    "feedBackOkCreate": "Grupo de turno creado.",
    "form": {
      "name": "Nombre del grupo",
      "namePlaceholder": "Escriba el nombre del grupo de turno",
      "type": "Tipo de turno",
      "typeInfo": "Seleccione el checkbox turno dinámico si la estructura de este turno no sigue un patrón fijo.",
      "typeHelp": "Turno que no sigue una estructura con un patrón fijo.",
      "workingShiftStructureDays": "Días de la estructura de turno",
      "workingShiftStructureDaysPlaceholder": "Escriba la cantidad de días de la estructura de turno (incluyendo descansos)",
      "workingShiftStructureDaysHelp": "Corresponde a la cantidad total de días que componen la estructura de turno (días de trabajo y días de descanso).",
      "planification": "Planificación horario del grupo de turno",
      "planificationHelp": "Corresponde a la planificación de hora de inicio y término para cada día de trabajo dentro del turno además de la planificación de los días de descanso.",
      "planificationHelp2": "Esta planificación se repetirá de forma cíclica a partir de la fecha de inicio ingresada.",
      "planificationTable": {
        "days": "DÍA",
        "workingDayType": "Tipo de jornada",
        "workType": "Trabajo",
        "restType": "Descanso",
        "startTime": "Hora de inicio",
        "endTime": "Hora de término",
        "hourPlaceholder": "Introduzca hora"
      },
      "workingShiftStartDate": "Fecha inicio régimen",
      "workingShiftStartDatePlaceholder": "Introduzca la fecha de inicio para este grupo de turno",
      "workingShiftStartDateHelp": "Corresponde a la fecha en la que comenzará a trabajar el grupo de trabajo.",
      "allowedTimeFFD": "Envío de informe Cognus con antelación al inicio de jornada (mins)",
      "allowedTimeFFDPlaceholder": "Introduzca el tiempo permitido",
      "allowedTimeFFDHelp": "Tiempo de antelación a la hora de inicio de jornada, según el cual se debe enviar el informe de Cognus PVT.",
      "allowedTimeFFDHelp2": "Ejemplo: Si el tiempo de antelación es de 20 minutos y la hora de inicio de jornada es 8:00 am, entonces el informe se enviará aprox. a las 7:40 am.",
      "maxLateTimeFFD": "Máximo de tiempo permitido para atraso en evalución de Cognus (mins)",
      "maxLateTimeFFDPlaceholder": "Introduzca el tiempo permitido",
      "maxLateTimeFFDHelp": "Tiempo máximo permitido que el sistema esperará para evaluar el Cognus de una persona de forma posterior al inicio de jornada.",
      "maxLateTimeFFDHelp2": "Ejemplo: si desea que los individuos que realizan la prueba Cognus 31 o más minutos después del inicio de jornada sean registrados como “incidente de realización”,  entonces el parámetro debe ser configurado en 30 minutos.",
      "maxAdvanceTimeFFD": "Máximo de tiempo permitido para anticipo en evalución de Cognus (mins)",
      "maxAdvanceTimeFFDPlaceholder": "Introduzca el tiempo permitido",
      "maxAdvanceTimeFFDHelp": "Tiempo máximo permitido que el sistema considerará para recibir información de evaluación de prueba Cognus antes de la hora de inicio de jornada.",
      "maxAdvanceTimeFFDHelp2": "Ejemplo: si desea que las personas tengan la oportunidad de realizar la prueba Cognus hasta 2 horas antes del inicio de jornada entonces el parámetro debe ser configurado en 120 minutos.",
      "mailRecipients": "Emails de notificación Cognus",
      "mailRecipientsPlaceholder": "Introduzca los correos separados por una coma",
      "mailRecipientsHelp": "Corresponde a la lista de correos electrónicos a los cuales notificar los estados de rechazo de evaluación Cognus y de incidentes de realización de prueba PVT."
    }
  },
  "accountTag": {
    "header": {
      "title": "Categorías"
    },
    "card": {
      "list": {
        "title": "Categorías",
        "create": "Crear categorías",
        "name": "Nombre",
        "click": "Haz click para agregar un ítem",
        "action": "Acciones",
        "label_alert": "El nombre de la categoría debe tener al menos una letra",
        "legend_text": "No hay categorías creadas",
        "placeholder": "Agregar una categoría ...",
        "label": "Añade otra categoría presionando Enter o cancelar presionando Esc"
      },
      "item": {
        "title": "Ítems de categoría",
        "create": "Agregar ítem",
        "name": "Nombre",
        "action": "Acciones",
        "legend_text": "No hay ítems creados",
        "label": "Añade otro ítem presionando Enter o cancelar presionando Esc",
        "label_alert": "El nombre del ítem solo puede contener letras y/o números, tener al menos un caracter y no comenzar con un número.",
        "placeholder": "Agregar un ítem a la categoría",
        "btn_cancel": "Cancelar",
        "btn_save": "Guardar"
      },
      "input": {
        "addItemLabel": "agregar ítem",
        "labelAlert": "El nombre de la categoría debe tener al menos una letra"
      },
      "toastrLabel": {
        "info": "Información",
        "error": "Error",
        "confirm": "Si",
        "cancel": "No",
        "delete": "Eliminar",
        "create": "Crear",
        "questionPart1": "Estas seguro que quieres guardar los siguientes cambios en la categoría",
        "questionPart1Cancel": "¿Esta seguro que quieres cancelar los cambios?. Perderá todas sus modificaciones.",
        "caution": "Esta acción hará que la trazabilidad histórica de los ítems eliminados sea eliminada de la plataforma.",
        "allTagsCreated": "Todos los cambios guardados con éxito.",
        "someTagsCreated": "Algunos cambios no fueron guardados con éxito.",
        "someTagsCreatedDetail": "Cambios no guardados:",
        "noTagsCreated": "Ningún cambio pudo ser guardado.",
        "tagsCreationError": "Los cambios no se han guardado, vuelva a intentarlo."
      }
    }
  },
  "accountList": {
    "header": {
      "title": "Listas de checklist digitales"
    },
    "card": {
      "list": {
        "title": "Listas",
        "create": "Crear listas",
        "name": "Nombre",
        "click": "Haz click para agregar una lista",
        "action": "Acciones",
        "label_alert": "El nombre de la lista solo puede contener letras y/o números y tener al menos una caracter.",
        "legend_text": "No hay listas creadas",
        "placeholder": "Agregar una lista ...",
        "label": "Añade otra lista presionando Enter o cancelar presionando Esc"
      },
      "item": {
        "title": "Ítems de lista",
        "create": "Agregar ítem",
        "name": "Nombre",
        "action": "Acciones",
        "legend_text": "No hay ítems creados",
        "label": "Añade otro ítem presionando Enter o cancelar presionando Esc",
        "label_alert": "El nombre del ítem solo puede contener letras y/o números y tener al menos un caracter.",
        "placeholder": "Agregar un ítem a la lista",
        "btn_cancel": "Cancelar",
        "btn_cancel_help": "Para volver a editar las listas debes guardar o cancelar.",
        "btn_save": "Guardar",
        "editItem": "Editar ítem"
      },
      "input": {
        "addItemLabel": "agregar ítem",
        "labelAlert": "El nombre de la lista debe tener al menos una letra"
      },
      "toastrLabel": {
        "info": "Información",
        "error": "Error",
        "confirm": "Si",
        "cancel": "No",
        "delete": "Eliminar",
        "create": "Crear",
        "update": "Editar",
        "questionPart1": "Estas seguro que quieres guardar los siguientes cambios en la lista",
        "questionPart1Cancel": "¿Esta seguro que quieres cancelar los cambios?. Perderá todas sus modificaciones.",
        "questionPart1DeleteList": "¿Estas seguro que quieres eliminar la lista",
        "cautionListDelete": "Eliminar una lista que está siendo utilizada por un checklist digital podría generar comportamientos inesperados.",
        "allItemsCreated": "Todos los cambios guardados con éxito.",
        "someItemsCreated": "Algunos cambios no fueron guardados con éxito.",
        "someItemsCreatedDetail": "Cambios no guardados:",
        "noItemsCreated": "Ningún cambio pudo ser guardado.",
        "itemsCreationError": "Los cambios no se han guardado, vuelva a intentarlo.",
        "listDeleted": "La lista ha sido eliminada con exito.",
        "listDeletedError": "La lista no pudo ser eliminada.",
        "listCreated": "La lista ha sido creada con exito.",
        "listCreatedError": "La lista no pudo ser creada."
      }
    }
  },
  "accountExtendedProperty": {
    "title": "Atributos adicionales",
    "table": {
      "name": "Nombre",
      "dataType": "Tipo de dato",
      "owner": "Propietario",
      "actions": "Acciones",
      "date": "Fecha",
      "text": "Texto",
      "person": "Persona",
      "vehicle": "Equipo",
      "semitrailer": "Rampla"
    },
    "buttons": {
      "createExtendedProperty": "Crear atributo"
    },
    "modal": {
      "buttonCreate": "Crear atributo",
      "buttonDelete": "Eliminar",
      "editText": "Editar",
      "buttonCancel": "Cancelar",
      "buttonEdit": "Actualizar atributo",
      "buttonUpdate": "Actualizar",
      "createTitle": "Crear atributo",
      "deleteTitle": "Eliminar atributo",
      "editTitle": "Editar atributo",
      "loading": "Cargando !!!",
      "feedBackOk": "Atributo creado.",
      "feedBackOkEdit": "Atributo actualizado.",
      "feedBackDeleteOne": "El atributo",
      "feedBackDeleteTwo": "fue eliminado exitosamente.",
      "name": "Nombre",
      "errorDelete": "Error al eliminar",
      "isSureToDeleteOne": "¿ Está seguro que desea eliminar el atributo",
      "isSureToDeleteTwo": "de la plataforma ?",
      "isSureToDeleteThree": "Está acción hará que desde este momento los propietarios de este atributo y los formularios a los que afecta pierdan esta información.",
      "buttonOK": "Ok"
    },
    "filter": {
      "show": "Mostrar",
      "allProperties": "Todos los atributos",
      "person": "Atributos de persona",
      "vehicle": "Atributos de equipo",
      "semiTrailer": "Atributos de rampla"
    },
    "help": {
      "title": "Representan los atributos adicionales que se podrán configurar para una persona o un equipo, por ejemplo: fecha de licencia de conducir, rampla de un equipo, cursos vencidos, entre otros. Estos se visualizarán y deberán ser completados tanto en preguntas de inspecciones como en la creación de equipos y personas.",
      "dataType": "Representa si el atributo corresponde a un texto o una fecha específica. Por ejemplo: fecha de vencimiento de una licencia de conducir o rampla de un equipo en particular.",
      "owner": "Corresponde a la entidad (equipos, ramplas o personas) a los que afecta este atributo.",
      "formName": "Escriba el nombre para este atributo",
      "formDataType": "Seleccione el tipo de dato de este atributo",
      "formOwner": "Seleccione a quien afecta este atributo"
    }
  },
  "others": {
    "categories": "Categorías",
    "selectOneItem": "Seleccione al menos un ítem",
    "loading": "Cargando",
    "incorrectFormat": "El formato del archivo es incorrecto",
    "noData": "No hay datos",
    "downloadFormat": "Descargar plantilla de formato",
    "save": "Guardar",
    "categoriesHelp": "Configura las categorías para los permisos seleccionados",
    "selectOneItemCategories": "Categorías para todos los permisos: Selecciona un item para cada categoría.",
    "selectMultipleItemsCategories": "Categorías para permisos modulo gestionador: Selecciona uno o mas items para cada categoría a visualizar en el modulo gestionador.",
    "changeStateMultipleSelectQuestion": "¿Estas seguro de agregar otros permisos además de los permisos del gestionador a este usuario?",
    "changeStateMultipleSelectWarning": "Al realizar esta acción todas las categorías asignadas a este usuario se borrarán y deberán ser completadas nuevamente.",
    "categoryAccessDenied": "Todos los ítems de ésta categoría se encuentran deshabilitadas dado que los permisos no coinciden con los del actual usuario",
    "selectOnlyOneItem": "Seleccione sólo un ítem por categoría",
    "disclaimerCategories": "Los cambios realizados en las Categorías, se verán reflejados en la plataforma el día",
    "formWithErrors": "Formulario con errores",
    "reviewInformationBeforeSending": "Revise la información del formulario antes de enviarlo",
    "at": "a las",
    "shouldSelectOnlyOneItem": "Debe seleccionar sólo un item",
    "has": "tiene",
    "disclaimerAssociateUsers": "<b>IMPORTANTE</b>: Una vez finalizado el proceso, <b>DEBES</b> guardar el archivo Excel descargado para consultar el resumen del proceso."
  },
  "date": {
    "format": "DD-MM-YYYY",
    "formatShort": "DD-MM",
    "graphFormatTooltip": "%d-%m-%Y",
    "graphFormatXAxis": "%d-%m"
  }
};


// WEBPACK FOOTER //
// ./source/client/components/locales/language_configuration/spanish/account/account.js